
  // 封装的Tab切换函数
function initializeTabs(tabButtonSelector, tabContentSelector) {
    const tabButtons = document.querySelectorAll(tabButtonSelector);
    const tabContents = document.querySelectorAll(tabContentSelector);
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function() {
        // 切换激活状态
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // 激活当前点击的tab和内容
        button.classList.add('active');
        tabContents[index].classList.add('active');
      });
    });
}

document.addEventListener('DOMContentLoaded', () => {
  // 调用懒加载函数
 
  initializeTabs('.tabs-btn li', '.auto-product-content .product-wrap');
  initializeTabs('.tabs-content li', '.auto-product-content .product-wrap');
  const slideBannerConfig = {
    effect: 'fade',
    loop: true,
    // autoplay: {
    //   delay: 5000,
    // },
    speed: 1500,
    pagination: {
      el: '.home-banner-container > .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".home-banner-container > .swiper-button-next",
      prevEl: ".home-banner-container > .swiper-button-prev",
    },
};
let SlideBannerSwiper = new Swiper(".home-banner-container", slideBannerConfig);
lazyLoadImages();
});
